import { Controller } from "@hotwired/stimulus"

// Filters the topic directory as you type. Opens the folded "quiet topics" list while filtering,
// so a match in there is never hidden behind a closed <details>.
export default class extends Controller {
  static targets = ["input", "item", "quiet", "empty"]

  filter() {
    const q = this.inputTarget.value.trim().toLowerCase()
    let shown = 0
    this.itemTargets.forEach((el) => {
      const match = !q || el.dataset.name.includes(q)
      el.hidden = !match
      if (match) shown++
    })
    if (this.hasQuietTarget) {
      if (q) {
        if (this.restoreOpen === undefined) this.restoreOpen = this.quietTarget.open
        this.quietTarget.open = true
      } else if (this.restoreOpen !== undefined) {
        this.quietTarget.open = this.restoreOpen
        this.restoreOpen = undefined
      }
    }
    if (this.hasEmptyTarget) this.emptyTarget.hidden = shown > 0
  }
}
